
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as explorepLxqUFyuGEXsktl3Qvs52GfK_45XGagppMpqfHX9D36rkMeta } from "/usr/src/app/pages/explore.vue?macro=true";
import { default as profilerquZOdO0EbghhTs0_uTo7_45Kngk8Yoi7STx_450BGNpf8IMeta } from "/usr/src/app/pages/profile.vue?macro=true";
import { default as portfolioNvLO2qmRviKM5hXJ7ONqLERBFzc2hg1_45DjwFSFxqtFUMeta } from "/usr/src/app/pages/portfolio.vue?macro=true";
import { default as auto5d8ZbmukqbIHz47QrUXybygU_4583m0xB9KxYJijK5adEMeta } from "/usr/src/app/pages/login/auto.vue?macro=true";
import { default as sent98FS9DHgwHjyrdw17oOYeldfzOCOmRAP2p67Niq0fMUMeta } from "/usr/src/app/pages/reset/sent.vue?macro=true";
import { default as indexheIeQbzM9wLVSuMwWpaQiLiL4W4bdha841uk8k5lUScMeta } from "/usr/src/app/pages/admin/index.vue?macro=true";
import { default as check1Xy4ccf0hYXa8Ezrz_45uR1Rg9TN6dC_45Z3JGjTelZ0AdkMeta } from "/usr/src/app/pages/login/check.vue?macro=true";
import { default as emailVgWhkF_oGlQrCir_kVdxc0LXIudB5n_a5XRILnAaWP8Meta } from "/usr/src/app/pages/login/email.vue?macro=true";
import { default as indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta } from "/usr/src/app/pages/login/index.vue?macro=true";
import { default as indexONzPk2pV0BIwSdmomNoqz16XFtTc1USXtnXyXb6NOnYMeta } from "/usr/src/app/pages/reset/index.vue?macro=true";
import { default as add_45propertyFwqoOpKq1sFRLrloKQSiL9slDNYCWVjE8GRKfp2xy64Meta } from "/usr/src/app/pages/add-property.vue?macro=true";
import { default as verifybRvHgKfRMtSLeRuk69LDxDG6dg8YM0qjqZzDqCixH3UMeta } from "/usr/src/app/pages/login/verify.vue?macro=true";
import { default as emailLUiM_R7KsS3p3YIFMuQ4l7TSkUbDcVSbUk_jj07lQYMMeta } from "/usr/src/app/pages/signup/email.vue?macro=true";
import { default as indexiYfC9AJ3VhIIva16wasaFSQz5iNu1lgdA4IllRk6WaQMeta } from "/usr/src/app/pages/signup/index.vue?macro=true";
import { default as _91id_93kb9bjXUZrWGs1qdGCw1Nz_S3pGR9bxgzON5Vj1hUH78Meta } from "/usr/src/app/pages/property/[id].vue?macro=true";
import { default as successS_DSly0hbmce4Nri2uByZmbbzgg1bz8Wm8sFLvr83fcMeta } from "/usr/src/app/pages/reset/success.vue?macro=true";
import { default as _91id_93TjVpyDC9FohiRcC1bnQgjBXSbMIZca67jkc00vKl8PcMeta } from "/usr/src/app/pages/services/[id].vue?macro=true";
import { default as failedZMg6BTg5eaUIvnvn2Ox5cotVYqOUL8NtYdSiSHcpXjMMeta } from "/usr/src/app/pages/payment/failed.vue?macro=true";
import { default as passwordyZzfleCrhsGzlYQoMRwVUhstiasyDvmo1Ak2kL9FgjoMeta } from "/usr/src/app/pages/reset/password.vue?macro=true";
import { default as indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta } from "/usr/src/app/pages/services/index.vue?macro=true";
import { default as contactiE3rLZl094u_JJl_6nbWUL0HFPdKn_jKxBtUnkjtDNAMeta } from "/usr/src/app/pages/signup/contact.vue?macro=true";
import { default as welcomejrpQs9yHWWP32lct_45KdlrhWb4BzrnSbWUWwsNfadyj8Meta } from "/usr/src/app/pages/signup/welcome.vue?macro=true";
import { default as index7FErS2FZdCc3nptG_45Y_zGgBG_45MgWkSKdFSIIDuuSCHYMeta } from "/usr/src/app/pages/training/index.vue?macro=true";
import { default as successCihTq4DE_UGrltcjE_oG6FFh1yXlFZCRNTPi4pTSE4MMeta } from "/usr/src/app/pages/payment/success.vue?macro=true";
import { default as _91id_93V6TiAuNNPv2lJ5_45xp8m1TROfwZzabIUomVoFdvCMRiIMeta } from "/usr/src/app/pages/properties/[id].vue?macro=true";
import { default as password76ZjmO5rQF8sYiBrWAzMljIFEjSgdamwkO8csEnrNpcMeta } from "/usr/src/app/pages/signup/password.vue?macro=true";
import { default as _91slug_93eh87CLWxF9zmzSb_45dC8z_45m70mhzBRBHZMggVyLas0nQMeta } from "/usr/src/app/pages/training/[slug].vue?macro=true";
import { default as indexZLYQ8fDwPFkWNtKloeYk5uEnQbR3BebLOi0lL_hIQEAMeta } from "/usr/src/app/pages/admin/users/index.vue?macro=true";
import { default as abandonedbuKhM7UJnAtKWJFZUytwX0UKRUzTmuvKRTLUxoQVmxAMeta } from "/usr/src/app/pages/payment/abandoned.vue?macro=true";
import { default as thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta } from "/usr/src/app/pages/services/thank-you.vue?macro=true";
import { default as _91id_93unlNT8JnDVHxXuwudC5utfpOyEX_45R1lThhDnrmuGGb4Meta } from "/usr/src/app/pages/admin/packages/[id].vue?macro=true";
import { default as _91id_9324RLyENccp0kuLN3IsquBdrfh3TbdaowW1W76zs8eisMeta } from "/usr/src/app/pages/admin/services/[id].vue?macro=true";
import { default as _91id_937GLCTrFVlNhLfBDVPtfcS6QLIBaclb5_M77lUu3naNAMeta } from "/usr/src/app/pages/admin/training/[id].vue?macro=true";
import { default as indexp9M2HIAmvBUyWLQ6eYEWlTX8Dl_Dfxryg6YmqVk3a9kMeta } from "/usr/src/app/pages/admin/packages/index.vue?macro=true";
import { default as indexEBWTFfEKoZAv1rhzjWBzKro4uWRUW8qhOTag4xPj1cMMeta } from "/usr/src/app/pages/admin/services/index.vue?macro=true";
import { default as indexNx5rXMS8CTJa5FmWIUSLZiCQwkDtBOh2k9rlwzY9KPUMeta } from "/usr/src/app/pages/admin/training/index.vue?macro=true";
import { default as createKgl0UaLfqhle0SWKc0Er9_453IL6CikifD2KyJROehzigMeta } from "/usr/src/app/pages/admin/packages/create.vue?macro=true";
import { default as indexWnTQoJMMuhQFDR_45UOb3MmSIDBLwK8fBU_nwbQrv9sisMeta } from "/usr/src/app/pages/admin/portfolio/index.vue?macro=true";
import { default as createJOMwe_jqlWz45vn00sdNfzVa4WWrmahGbpTlDC33_45_YMeta } from "/usr/src/app/pages/admin/services/create.vue?macro=true";
import { default as created29qSRyZK76XezIGz8Q4OXIUdFF4L3k2eTlWd8w72GMMeta } from "/usr/src/app/pages/admin/training/create.vue?macro=true";
import { default as indexNMKf08aXmqUIAPD9ltH9Ty3y11HxUl_45W7FOKz10IC9YMeta } from "/usr/src/app/pages/property/[hash]/index.vue?macro=true";
import { default as _91id_93jtdljeQubUjMUVpJmE_45JYnzzxWU2bKLuJfrZ_453AsgxYMeta } from "/usr/src/app/pages/property/[hash]/unit/[id].vue?macro=true";
import { default as _91id_93rfnhHlm8EI_45_45y68pQeghQ8biMVDapWQ9EwtwOA3Wn7UMeta } from "/usr/src/app/pages/admin/points-of-interest/[id].vue?macro=true";
import { default as indexOSiHbOo4UvRKAzmlILr0Qa0IaySLFN_45eF4ACoxpe8E0Meta } from "/usr/src/app/pages/admin/points-of-interest/index.vue?macro=true";
import { default as createvNpKohJR26couO2wn0bYY9ZF2yZMSshmmRYss4PluTQMeta } from "/usr/src/app/pages/admin/points-of-interest/create.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "explore___en",
    path: "/en/explore",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "explore___de",
    path: "/de/explore",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/explore.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/profile.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/profile.vue")
  },
  {
    name: "portfolio___en",
    path: "/en/portfolio",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/portfolio.vue")
  },
  {
    name: "portfolio___de",
    path: "/de/portfolio",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/portfolio.vue")
  },
  {
    name: "login-auto___en",
    path: "/en/login/auto",
    meta: auto5d8ZbmukqbIHz47QrUXybygU_4583m0xB9KxYJijK5adEMeta || {},
    component: () => import("/usr/src/app/pages/login/auto.vue")
  },
  {
    name: "login-auto___de",
    path: "/de/login/auto",
    meta: auto5d8ZbmukqbIHz47QrUXybygU_4583m0xB9KxYJijK5adEMeta || {},
    component: () => import("/usr/src/app/pages/login/auto.vue")
  },
  {
    name: "reset-sent___en",
    path: "/en/reset/sent",
    meta: { ...(sent98FS9DHgwHjyrdw17oOYeldfzOCOmRAP2p67Niq0fMUMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/sent.vue")
  },
  {
    name: "reset-sent___de",
    path: "/de/reset/sent",
    meta: { ...(sent98FS9DHgwHjyrdw17oOYeldfzOCOmRAP2p67Niq0fMUMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/sent.vue")
  },
  {
    name: "admin___en",
    path: "/en/admin",
    meta: { ...(indexheIeQbzM9wLVSuMwWpaQiLiL4W4bdha841uk8k5lUScMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/index.vue")
  },
  {
    name: "admin___de",
    path: "/de/admin",
    meta: { ...(indexheIeQbzM9wLVSuMwWpaQiLiL4W4bdha841uk8k5lUScMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/index.vue")
  },
  {
    name: "login-check___en",
    path: "/en/login/check",
    meta: { ...(check1Xy4ccf0hYXa8Ezrz_45uR1Rg9TN6dC_45Z3JGjTelZ0AdkMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/check.vue")
  },
  {
    name: "login-check___de",
    path: "/de/login/check",
    meta: { ...(check1Xy4ccf0hYXa8Ezrz_45uR1Rg9TN6dC_45Z3JGjTelZ0AdkMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/check.vue")
  },
  {
    name: "login-email___en",
    path: "/en/login/email",
    meta: { ...(emailVgWhkF_oGlQrCir_kVdxc0LXIudB5n_a5XRILnAaWP8Meta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/email.vue")
  },
  {
    name: "login-email___de",
    path: "/de/login/email",
    meta: { ...(emailVgWhkF_oGlQrCir_kVdxc0LXIudB5n_a5XRILnAaWP8Meta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/email.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/index.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: { ...(indexDKVd05MLJnFC29f0eB5ZuesuyGzzyi_7ngIkziaq_H8Meta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/index.vue")
  },
  {
    name: "reset___en",
    path: "/en/reset",
    meta: { ...(indexONzPk2pV0BIwSdmomNoqz16XFtTc1USXtnXyXb6NOnYMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/index.vue")
  },
  {
    name: "reset___de",
    path: "/de/reset",
    meta: { ...(indexONzPk2pV0BIwSdmomNoqz16XFtTc1USXtnXyXb6NOnYMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/index.vue")
  },
  {
    name: "add-property___en",
    path: "/en/add-property",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/add-property.vue")
  },
  {
    name: "add-property___de",
    path: "/de/add-property",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/add-property.vue")
  },
  {
    name: "login-verify___en",
    path: "/en/login/verify",
    meta: { ...(verifybRvHgKfRMtSLeRuk69LDxDG6dg8YM0qjqZzDqCixH3UMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/verify.vue")
  },
  {
    name: "login-verify___de",
    path: "/de/login/verify",
    meta: { ...(verifybRvHgKfRMtSLeRuk69LDxDG6dg8YM0qjqZzDqCixH3UMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/login/verify.vue")
  },
  {
    name: "signup-email___en",
    path: "/en/signup/email",
    meta: { ...(emailLUiM_R7KsS3p3YIFMuQ4l7TSkUbDcVSbUk_jj07lQYMMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/signup/email.vue")
  },
  {
    name: "signup-email___de",
    path: "/de/signup/email",
    meta: { ...(emailLUiM_R7KsS3p3YIFMuQ4l7TSkUbDcVSbUk_jj07lQYMMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/signup/email.vue")
  },
  {
    name: "signup___en",
    path: "/en/signup",
    meta: { ...(indexiYfC9AJ3VhIIva16wasaFSQz5iNu1lgdA4IllRk6WaQMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/signup/index.vue")
  },
  {
    name: "signup___de",
    path: "/de/signup",
    meta: { ...(indexiYfC9AJ3VhIIva16wasaFSQz5iNu1lgdA4IllRk6WaQMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/signup/index.vue")
  },
  {
    name: "property-id___en",
    path: "/en/property/:id()",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/property/[id].vue")
  },
  {
    name: "property-id___de",
    path: "/de/property/:id()",
    meta: {"middleware":["is-auth"]},
    component: () => import("/usr/src/app/pages/property/[id].vue")
  },
  {
    name: "reset-success___en",
    path: "/en/reset/success",
    meta: { ...(successS_DSly0hbmce4Nri2uByZmbbzgg1bz8Wm8sFLvr83fcMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/success.vue")
  },
  {
    name: "reset-success___de",
    path: "/de/reset/success",
    meta: { ...(successS_DSly0hbmce4Nri2uByZmbbzgg1bz8Wm8sFLvr83fcMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/success.vue")
  },
  {
    name: "services-id___en",
    path: "/en/services/:id()",
    meta: { ...(_91id_93TjVpyDC9FohiRcC1bnQgjBXSbMIZca67jkc00vKl8PcMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[id].vue")
  },
  {
    name: "services-id___de",
    path: "/de/services/:id()",
    meta: { ...(_91id_93TjVpyDC9FohiRcC1bnQgjBXSbMIZca67jkc00vKl8PcMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/[id].vue")
  },
  {
    name: "payment-failed___en",
    path: "/en/payment/failed",
    component: () => import("/usr/src/app/pages/payment/failed.vue")
  },
  {
    name: "payment-failed___de",
    path: "/de/payment/failed",
    component: () => import("/usr/src/app/pages/payment/failed.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset/password",
    meta: { ...(passwordyZzfleCrhsGzlYQoMRwVUhstiasyDvmo1Ak2kL9FgjoMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/password.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/reset/password",
    meta: { ...(passwordyZzfleCrhsGzlYQoMRwVUhstiasyDvmo1Ak2kL9FgjoMeta || {}), ...{"middleware":["is-auth-route"]} },
    component: () => import("/usr/src/app/pages/reset/password.vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    meta: { ...(indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "services___de",
    path: "/de/services",
    meta: { ...(indexzw2uLHyqkI9xDcZJvKpOvj83FJP4svIeH7wYZulHdDgMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/index.vue")
  },
  {
    name: "signup-contact___en",
    path: "/en/signup/contact",
    meta: contactiE3rLZl094u_JJl_6nbWUL0HFPdKn_jKxBtUnkjtDNAMeta || {},
    component: () => import("/usr/src/app/pages/signup/contact.vue")
  },
  {
    name: "signup-contact___de",
    path: "/de/signup/contact",
    meta: contactiE3rLZl094u_JJl_6nbWUL0HFPdKn_jKxBtUnkjtDNAMeta || {},
    component: () => import("/usr/src/app/pages/signup/contact.vue")
  },
  {
    name: "signup-welcome___en",
    path: "/en/signup/welcome",
    meta: { ...(welcomejrpQs9yHWWP32lct_45KdlrhWb4BzrnSbWUWwsNfadyj8Meta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/signup/welcome.vue")
  },
  {
    name: "signup-welcome___de",
    path: "/de/signup/welcome",
    meta: { ...(welcomejrpQs9yHWWP32lct_45KdlrhWb4BzrnSbWUWwsNfadyj8Meta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/signup/welcome.vue")
  },
  {
    name: "training___en",
    path: "/en/training",
    meta: { ...(index7FErS2FZdCc3nptG_45Y_zGgBG_45MgWkSKdFSIIDuuSCHYMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/training/index.vue")
  },
  {
    name: "training___de",
    path: "/de/training",
    meta: { ...(index7FErS2FZdCc3nptG_45Y_zGgBG_45MgWkSKdFSIIDuuSCHYMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/training/index.vue")
  },
  {
    name: "payment-success___en",
    path: "/en/payment/success",
    component: () => import("/usr/src/app/pages/payment/success.vue")
  },
  {
    name: "payment-success___de",
    path: "/de/payment/success",
    component: () => import("/usr/src/app/pages/payment/success.vue")
  },
  {
    name: "properties-id___en",
    path: "/en/properties/:id()",
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "properties-id___de",
    path: "/de/properties/:id()",
    component: () => import("/usr/src/app/pages/properties/[id].vue")
  },
  {
    name: "signup-password___en",
    path: "/en/signup/password",
    meta: password76ZjmO5rQF8sYiBrWAzMljIFEjSgdamwkO8csEnrNpcMeta || {},
    component: () => import("/usr/src/app/pages/signup/password.vue")
  },
  {
    name: "signup-password___de",
    path: "/de/signup/password",
    meta: password76ZjmO5rQF8sYiBrWAzMljIFEjSgdamwkO8csEnrNpcMeta || {},
    component: () => import("/usr/src/app/pages/signup/password.vue")
  },
  {
    name: "training-slug___en",
    path: "/en/training/:slug()",
    meta: { ...(_91slug_93eh87CLWxF9zmzSb_45dC8z_45m70mhzBRBHZMggVyLas0nQMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/training/[slug].vue")
  },
  {
    name: "training-slug___de",
    path: "/de/training/:slug()",
    meta: { ...(_91slug_93eh87CLWxF9zmzSb_45dC8z_45m70mhzBRBHZMggVyLas0nQMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/training/[slug].vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: { ...(indexZLYQ8fDwPFkWNtKloeYk5uEnQbR3BebLOi0lL_hIQEAMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/users/index.vue")
  },
  {
    name: "admin-users___de",
    path: "/de/admin/users",
    meta: { ...(indexZLYQ8fDwPFkWNtKloeYk5uEnQbR3BebLOi0lL_hIQEAMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/users/index.vue")
  },
  {
    name: "payment-abandoned___en",
    path: "/en/payment/abandoned",
    component: () => import("/usr/src/app/pages/payment/abandoned.vue")
  },
  {
    name: "payment-abandoned___de",
    path: "/de/payment/abandoned",
    component: () => import("/usr/src/app/pages/payment/abandoned.vue")
  },
  {
    name: "services-thank-you___en",
    path: "/en/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "services-thank-you___de",
    path: "/de/services/thank-you",
    meta: { ...(thank_45you45kF2h6PwmPnP_45IxLkHesHf_45MaQp0f66BpUhZK4uU1kMeta || {}), ...{"middleware":["is-auth"]} },
    component: () => import("/usr/src/app/pages/services/thank-you.vue")
  },
  {
    name: "admin-packages-id___en",
    path: "/en/admin/packages/:id()",
    meta: { ...(_91id_93unlNT8JnDVHxXuwudC5utfpOyEX_45R1lThhDnrmuGGb4Meta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/packages/[id].vue")
  },
  {
    name: "admin-packages-id___de",
    path: "/de/admin/packages/:id()",
    meta: { ...(_91id_93unlNT8JnDVHxXuwudC5utfpOyEX_45R1lThhDnrmuGGb4Meta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/packages/[id].vue")
  },
  {
    name: "admin-services-id___en",
    path: "/en/admin/services/:id()",
    meta: { ...(_91id_9324RLyENccp0kuLN3IsquBdrfh3TbdaowW1W76zs8eisMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/services/[id].vue")
  },
  {
    name: "admin-services-id___de",
    path: "/de/admin/services/:id()",
    meta: { ...(_91id_9324RLyENccp0kuLN3IsquBdrfh3TbdaowW1W76zs8eisMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/services/[id].vue")
  },
  {
    name: "admin-training-id___en",
    path: "/en/admin/training/:id()",
    meta: { ...(_91id_937GLCTrFVlNhLfBDVPtfcS6QLIBaclb5_M77lUu3naNAMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/training/[id].vue")
  },
  {
    name: "admin-training-id___de",
    path: "/de/admin/training/:id()",
    meta: { ...(_91id_937GLCTrFVlNhLfBDVPtfcS6QLIBaclb5_M77lUu3naNAMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/training/[id].vue")
  },
  {
    name: "admin-packages___en",
    path: "/en/admin/packages",
    meta: { ...(indexp9M2HIAmvBUyWLQ6eYEWlTX8Dl_Dfxryg6YmqVk3a9kMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/packages/index.vue")
  },
  {
    name: "admin-packages___de",
    path: "/de/admin/packages",
    meta: { ...(indexp9M2HIAmvBUyWLQ6eYEWlTX8Dl_Dfxryg6YmqVk3a9kMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/packages/index.vue")
  },
  {
    name: "admin-services___en",
    path: "/en/admin/services",
    meta: { ...(indexEBWTFfEKoZAv1rhzjWBzKro4uWRUW8qhOTag4xPj1cMMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/services/index.vue")
  },
  {
    name: "admin-services___de",
    path: "/de/admin/services",
    meta: { ...(indexEBWTFfEKoZAv1rhzjWBzKro4uWRUW8qhOTag4xPj1cMMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/services/index.vue")
  },
  {
    name: "admin-training___en",
    path: "/en/admin/training",
    meta: { ...(indexNx5rXMS8CTJa5FmWIUSLZiCQwkDtBOh2k9rlwzY9KPUMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/training/index.vue")
  },
  {
    name: "admin-training___de",
    path: "/de/admin/training",
    meta: { ...(indexNx5rXMS8CTJa5FmWIUSLZiCQwkDtBOh2k9rlwzY9KPUMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/training/index.vue")
  },
  {
    name: "admin-packages-create___en",
    path: "/en/admin/packages/create",
    meta: { ...(createKgl0UaLfqhle0SWKc0Er9_453IL6CikifD2KyJROehzigMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/packages/create.vue")
  },
  {
    name: "admin-packages-create___de",
    path: "/de/admin/packages/create",
    meta: { ...(createKgl0UaLfqhle0SWKc0Er9_453IL6CikifD2KyJROehzigMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/packages/create.vue")
  },
  {
    name: "admin-portfolio___en",
    path: "/en/admin/portfolio",
    meta: { ...(indexWnTQoJMMuhQFDR_45UOb3MmSIDBLwK8fBU_nwbQrv9sisMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/portfolio/index.vue")
  },
  {
    name: "admin-portfolio___de",
    path: "/de/admin/portfolio",
    meta: { ...(indexWnTQoJMMuhQFDR_45UOb3MmSIDBLwK8fBU_nwbQrv9sisMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/portfolio/index.vue")
  },
  {
    name: "admin-services-create___en",
    path: "/en/admin/services/create",
    meta: { ...(createJOMwe_jqlWz45vn00sdNfzVa4WWrmahGbpTlDC33_45_YMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/services/create.vue")
  },
  {
    name: "admin-services-create___de",
    path: "/de/admin/services/create",
    meta: { ...(createJOMwe_jqlWz45vn00sdNfzVa4WWrmahGbpTlDC33_45_YMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/services/create.vue")
  },
  {
    name: "admin-training-create___en",
    path: "/en/admin/training/create",
    meta: { ...(created29qSRyZK76XezIGz8Q4OXIUdFF4L3k2eTlWd8w72GMMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/training/create.vue")
  },
  {
    name: "admin-training-create___de",
    path: "/de/admin/training/create",
    meta: { ...(created29qSRyZK76XezIGz8Q4OXIUdFF4L3k2eTlWd8w72GMMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/training/create.vue")
  },
  {
    name: "property-hash___en",
    path: "/en/property/:hash()",
    component: () => import("/usr/src/app/pages/property/[hash]/index.vue")
  },
  {
    name: "property-hash___de",
    path: "/de/property/:hash()",
    component: () => import("/usr/src/app/pages/property/[hash]/index.vue")
  },
  {
    name: "property-hash-unit-id___en",
    path: "/en/property/:hash()/unit/:id()",
    component: () => import("/usr/src/app/pages/property/[hash]/unit/[id].vue")
  },
  {
    name: "property-hash-unit-id___de",
    path: "/de/property/:hash()/unit/:id()",
    component: () => import("/usr/src/app/pages/property/[hash]/unit/[id].vue")
  },
  {
    name: "admin-points-of-interest-id___en",
    path: "/en/admin/points-of-interest/:id()",
    meta: { ...(_91id_93rfnhHlm8EI_45_45y68pQeghQ8biMVDapWQ9EwtwOA3Wn7UMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/[id].vue")
  },
  {
    name: "admin-points-of-interest-id___de",
    path: "/de/admin/points-of-interest/:id()",
    meta: { ...(_91id_93rfnhHlm8EI_45_45y68pQeghQ8biMVDapWQ9EwtwOA3Wn7UMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/[id].vue")
  },
  {
    name: "admin-points-of-interest___en",
    path: "/en/admin/points-of-interest",
    meta: { ...(indexOSiHbOo4UvRKAzmlILr0Qa0IaySLFN_45eF4ACoxpe8E0Meta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/index.vue")
  },
  {
    name: "admin-points-of-interest___de",
    path: "/de/admin/points-of-interest",
    meta: { ...(indexOSiHbOo4UvRKAzmlILr0Qa0IaySLFN_45eF4ACoxpe8E0Meta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/index.vue")
  },
  {
    name: "admin-points-of-interest-create___en",
    path: "/en/admin/points-of-interest/create",
    meta: { ...(createvNpKohJR26couO2wn0bYY9ZF2yZMSshmmRYss4PluTQMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/create.vue")
  },
  {
    name: "admin-points-of-interest-create___de",
    path: "/de/admin/points-of-interest/create",
    meta: { ...(createvNpKohJR26couO2wn0bYY9ZF2yZMSshmmRYss4PluTQMeta || {}), ...{"middleware":["is-auth","is-admin"]} },
    component: () => import("/usr/src/app/pages/admin/points-of-interest/create.vue")
  }
]